import { BrowserRouter, Navigate, Route, Routes, useParams } from 'react-router-dom'

import RequireAuth from '../layouts/RequireAuth'
import Login from '../views/Login'
import NotFound from '../views/NotFound'
import Funcionalidades from '../views/Funcionalidades'
import Usuarios from '../views/Usuarios'
import AccessDenied from '../views/AccessDenied'

import DashboardEdit from '../views/DashboardEdit'
import EnvironmentEdit from '../views/EnvironmentEdit'
import DashboardNew from '../views/DashboardNew'
import RelatorioHtml from '../views/RelatorioHtml'
import BookDownload from '../views/BookDownload'
import TemplatesHtml from '../views/TemplatesHtml'
import DashboardEnvEdit from '../views/DashboardEnvEdit'
import ComptradeEst from '../views/ComptradeEst'
import ComptradeEstEdit from '../views/ComptradeEstEdit'
import DashboardRules from '../views/DashboardRules'
import DashboardRuleEdit from '../views/DashboardRuleEdit'
import TrctOverview from '../views/Trct'
import TrctInclude from '../views/TrctInclude'
import TrctLog from '../views/TrctLog'
import AiAgents from '../views/AiAgents'
import AiAgentsEdit from '../views/AiAgentsEdit'
import Marcas from '../views/Marcas'
import NovoDashboard from '../novo/dashboard/NovoDashboard'
import Inicio from '../novo/inicio/Inicio'
import Catalogo from '../novo/gestao/Catalogo'
import DashboardGeral from '../novo/gestao/DashboardGeral'
import GestaoAmbientes from '../novo/gestao/Ambientes'
import DashboardNoAmbiente from '../novo/gestao/DashboardNoAmbiente'
import GestaoRegras from '../novo/gestao/Regras'
import GestaoPessoas from '../novo/gestao/Pessoas'
import GestaoPessoa from '../novo/gestao/Pessoa'
import GestaoEquipes from '../novo/gestao/Equipes'
import GestaoAgentes from '../novo/gestao/Agentes'
import GestaoTemplates from '../novo/gestao/Templates'
import Solicitacoes from '../novo/solicitacoes/Solicitacoes'
import Kanban from '../novo/solicitacoes/Kanban'
import MinhaFila from '../novo/solicitacoes/MinhaFila'

/** O editor do relatório HTML mudou para a gestão nova; links antigos continuam chegando lá. */
function EditorHtmlAntigo() {
  const { id } = useParams()
  return <Navigate to={`/app/gestao/dashboards/${id}/html`} replace />
}

function SystemRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/app" element={<RequireAuth roles={['bi_dashboards_read_any', 'bi_dashboards_read']} />}>
          <Route path="/app/inicio" element={<Inicio />} />
          <Route path="/app/dashboard" element={<NovoDashboard />} />
          <Route path="/app/dashboard/:id/:envId" element={<NovoDashboard />} />
        </Route>
        {/* O link do book de fotos no e-mail: qualquer pessoa logada abre; o servidor confere se o book é dela. */}
        <Route path="/app/book" element={<RequireAuth />}>
          <Route path=":id" element={<BookDownload />} />
        </Route>
        <Route path="/app/dash_management"
               element={<RequireAuth roles={['bi_dashboards_create_any', 'bi_dashboards_create']} />}>
          <Route path="/app/dash_management/functionalities" element={<Funcionalidades />} />
          <Route path="/app/dash_management/agents" element={<AiAgents />} />
          <Route path="/app/dash_management/agents/:id" element={<AiAgentsEdit />} />
          <Route path="/app/dash_management/dashboard/:id" element={<DashboardEdit />} />
          <Route path="/app/dash_management/dashboard/:id/environment/:envId" element={<DashboardEnvEdit />} />
          <Route path="/app/dash_management/dashboard/new" element={<DashboardNew />} />
          <Route path="/app/dash_management/dashboard/:id/html" element={<EditorHtmlAntigo />} />
          <Route path="/app/dash_management/html_templates" element={<TemplatesHtml />} />
          <Route path="/app/dash_management/environment/:id" element={<EnvironmentEdit />} />
          <Route path="/app/dash_management/rules" element={<DashboardRules />} />
          <Route path="/app/dash_management/rules/:id" element={<DashboardRuleEdit />} />
        </Route>

        <Route path="/app/gestao/dashboards" element={<RequireAuth roles={['bi_dashboards_create_any', 'bi_dashboards_create']} />}>
          <Route index element={<Catalogo />} />
          <Route path=":id" element={<DashboardGeral />} />
          <Route path=":id/ambiente/:envId" element={<DashboardNoAmbiente />} />
          <Route path=":id/html" element={<RelatorioHtml />} />
        </Route>

        <Route path="/app/gestao/ambientes" element={<RequireAuth roles={['bi_dashboards_create_any', 'bi_dashboards_create']} />}>
          <Route index element={<GestaoAmbientes />} />
          <Route path=":id" element={<GestaoAmbientes />} />
        </Route>

        <Route path="/app/gestao/regras" element={<RequireAuth roles={['bi_dashboards_create_any', 'bi_dashboards_create', 'bi_dashboards_edit']} />}>
          <Route index element={<GestaoRegras />} />
          <Route path=":id" element={<GestaoRegras />} />
        </Route>

        <Route path="/app/gestao/pessoas" element={<RequireAuth roles={['bi_dashboards_create_any', 'bi_dashboards_create', 'bi_dashboards_edit']} />}>
          <Route index element={<GestaoPessoas />} />
          <Route path=":id" element={<GestaoPessoa />} />
        </Route>

        <Route path="/app/gestao/equipes" element={<RequireAuth roles={['bi_dashboards_create_any', 'bi_dashboards_create', 'bi_dashboards_edit']} />}>
          <Route index element={<GestaoEquipes />} />
          <Route path=":id" element={<GestaoEquipes />} />
        </Route>

        <Route path="/app/gestao/templates" element={<RequireAuth roles={['bi_dashboards_create_any', 'bi_dashboards_create', 'bi_dashboards_edit']} />}>
          <Route index element={<GestaoTemplates />} />
          <Route path=":id" element={<GestaoTemplates />} />
        </Route>

        <Route path="/app/gestao/agentes" element={<RequireAuth roles={['bi_dashboards_read_any', 'bi_dashboards_edit']} />}>
          <Route index element={<GestaoAgentes />} />
          <Route path=":id" element={<GestaoAgentes />} />
        </Route>

        <Route path="/app/gestao" element={<RequireAuth roles={['bi_dashboards_read_any']} />}>
          <Route path="/app/gestao/marcas" element={<Marcas />} />
        </Route>

        <Route path="/app/comptrade" element={<RequireAuth roles={['comptrade_read_est']} />}>
          <Route path="/app/comptrade/est" element={<ComptradeEst />} />
          <Route path="/app/comptrade/est/:id" element={<ComptradeEstEdit />} />

        </Route>

        <Route path="/app/trct" element={<RequireAuth roles={['showmenu_trct']} />}>
          <Route path="/app/trct/list" element={<TrctOverview />} />
          <Route path="/app/trct/include" element={<TrctInclude />} />
          <Route path="/app/trct/log" element={<TrctLog />} />
        </Route>

        <Route path="/app/dash_management" element={<RequireAuth roles={['showmenu_bi_dashboards_edit']} />}>
          <Route path="/app/dash_management/users" element={<Usuarios />} />
        </Route>

        <Route path="/app/solicitacoes" element={<RequireAuth roles={['solicitacoes', 'gestao_solicitacoes', 'bi_dashboards_read_any']} />}>
          <Route index element={<Solicitacoes />} />
        </Route>

        <Route path="/app/gestao/solicitacoes" element={<RequireAuth roles={['gestao_solicitacoes', 'bi_dashboards_read_any']} />}>
          <Route index element={<Kanban />} />
        </Route>

        <Route path="/app/gestao/minha-fila" element={<RequireAuth roles={['gestao_solicitacoes', 'bi_dashboards_read_any']} />}>
          <Route index element={<MinhaFila />} />
        </Route>

        <Route path="/nao-autorizado" element={<AccessDenied />} />

        <Route path="/auth" element={<Login />}>
          <Route path="/auth" element={<Login />} />
          <Route path="/auth/signin" element={<Login />} />
        </Route>
        <Route path="/" element={<Login />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  )
}

export default SystemRoutes
